import styled from 'styled-components/macro'
import { Box, EthSign, Flex } from 'components/ui';
import VoxViewer from 'components/VoxViewer';
import useMixpassSaleStatus from 'hooks/useMixpassSaleStatus';

const Pixelated = styled.div`
  font-family: 'VT323', monospace;
  color: white;
  font-size: 24px;
`;

const Price = () => {
  const { price, isLoading } = useMixpassSaleStatus();

  if (isLoading) return null;

  return (
    <Pixelated>
      <Flex alignCenter justifyCenter px={3} fontWeight="bold">
        <EthSign fontFamily="Arial" value={price && price.toString()} />
        <Box ml="1">
          each
        </Box>
      </Flex>
    </Pixelated>
  );
};

const RemainingSupply = () => {
  const { remainingSupply, isLoading } = useMixpassSaleStatus();

  if (isLoading) return null;

  return (
    <Box textAlign="center" px={3} fontWeight="bold">
      <Pixelated>
      {remainingSupply ? remainingSupply.toString() : '0'} Remaining
      </Pixelated>
    </Box>
  );
};

const MixpassImage = () => {
  return (
    <Box width="100%" textAlign="center">
      <VoxViewer model="futura-headphones" />
    </Box>
  );
};

const MixpassDetails = () => {
  return (
    <Flex width="100%" minHeight={['auto', 'auto', 'calc(100vh - 200px)']} justifyContent="center" alignCenter>
      <Box>
        <MixpassImage />
        <Flex width="100%" marginTop={-4} pb={4} alignCenter justifyCenter>
          <RemainingSupply />
          <Price />
        </Flex>
      </Box>
    </Flex>
  );
};

export default MixpassDetails;
